<!-- main swipe cards container -->
<div class="swipe-cards-container">
    <!-- swipe card list -->
    <div class="swipe-cards" (pan)="handlePan($event)" (panend)="handlePanEnd($event)">
        <div #swipeCard class="swipe-card" (transitionend)="handleShift()" *ngFor="let card of cards; let i = index"
            [ngStyle]="{ zIndex: cards.length - i, transform: 'scale(' + (20 - i) / 20 + ')' }">
            <h1 class="h3">{{ card.question }}</h1>
            <img #swipeCardImage [src]="card.img" (load)="swipeCardImage.style.opacity = 1">
            <div class="card--movement">
                <div [style.opacity]="crossVisible? '1':'0'">
                    <img src="assets/icons/false.png" class="false" alt="false">
                </div>
                <div [style.opacity]="heartVisible? '1':'0'">
                    <img src="assets/icons/true.png" class="true" alt="true">
                </div>
            </div>
        </div>
    </div>
    <!-- ./end swipe card list -->
    <!-- swipe card background -->
    <div class="swipe-cards-background"></div>
    <!-- ./end swipe card background -->
    <!-- swipe card buttons -->
    <div class="swipe--buttons">
        <!-- false button -->
        <div (click)="userClickedButton($event, false)">
            <img src="assets/icons/wrong_answers_active.png" alt="wrong">
        </div>
        <!-- ./end false button -->
        <!-- true button -->
        <div (click)="userClickedButton($event, true)">
            <img src="assets/icons/correct_answers_active.png" alt="correct">
        </div>
        <!-- ./end true button -->
    </div>
    <!-- ./end swipe card buttons -->
</div>
<!-- ./end main swipe cards container -->